import Actions from "../action";


const initialState = {
  healthCheckData: null,
  hostels: [],
  loading: false,
  error: null,
  downtimeReportData: null,
  downtimeReportLoading: false,
  downtimeReportError: null,
};


const HealthCheckReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_HEALTH_CHECK_DATA:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case Actions.GET_HEALTH_CHECK_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        healthCheckData: action.data?.response ?? null,
        hostels: Array.isArray(action.data?.hostels) ? action.data.hostels : [],
        error: null,
      };

    case Actions.GET_HEALTH_CHECK_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.data,
        healthCheckData: null,
      };

    case Actions.GET_DOWNTIME_REPORT:
      return {
        ...state,
        downtimeReportLoading: true,
        downtimeReportError: null,
      };

    case Actions.GET_DOWNTIME_REPORT_SUCCESS:
      return {
        ...state,
        downtimeReportLoading: false,
        downtimeReportData: action.data,
        downtimeReportError: null,
      };

    case Actions.GET_DOWNTIME_REPORT_FAILURE:
      return {
        ...state,
        downtimeReportLoading: false,
        downtimeReportError: action.data,
        downtimeReportData: null,
      };

    default:
      return state;
  }
}


export const getHealthCheckDataSelector = (state) =>
  state.HEALTH_CHECKER.healthCheckData;

export const getHealthCheckHostelsSelector = (state) =>
  state.HEALTH_CHECKER.hostels || [];

export const getHealthCheckLoadingSelector = (state) => 
  state.HEALTH_CHECKER.loading;

export const getHealthCheckErrorSelector = (state) =>
  state.HEALTH_CHECKER.error;

export const getDowntimeReportDataSelector = (state) =>
  state.HEALTH_CHECKER.downtimeReportData;

export const getDowntimeReportLoadingSelector = (state) =>
  state.HEALTH_CHECKER.downtimeReportLoading;

export const getDowntimeReportErrorSelector = (state) =>
  state.HEALTH_CHECKER.downtimeReportError;

export default HealthCheckReducer;